import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Printer } from "lucide-react";
import { rp, fmtDateTime, METHOD_LABEL } from "@/lib/api";
import { StageBadge } from "@/components/common";
import { TotalsBlock, ItemStatus } from "@/components/BillItems";
import { printReceipt } from "@/components/Receipt";
import { useAuth } from "@/context/AuthContext";

export default function BillDetailDialog({ bill, open, onOpenChange }) {
  const { settings } = useAuth();
  if (!bill) return null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto" data-testid="bill-detail-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-3">
            <span className="font-mono">{bill.code}</span>
            <StageBadge stage={bill.stage} testId="bill-detail-stage" />
          </DialogTitle>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-3 rounded-xl bg-stone-50 p-3 text-sm">
          <Info k="Pelanggan" v={bill.customer_name} />
          <Info k="Meja" v={bill.table_name} />
          <Info k="Waiter" v={bill.waiter_name} />
          <Info k="Dibuka" v={fmtDateTime(bill.created_at)} />
          {bill.payment && <Info k="Pembayaran" v={METHOD_LABEL[bill.payment.method]} />}
          {bill.paid_at && <Info k="Dibayar" v={fmtDateTime(bill.paid_at)} />}
        </div>
        <div className="divide-y divide-stone-100" data-testid="bill-detail-items">
          {bill.items.length === 0 && <p className="py-6 text-center text-sm text-zinc-500">Belum ada menu dipesan</p>}
          {bill.items.map((i) => (
            <div key={i.id} className="flex items-start justify-between gap-3 py-2.5">
              <div className="min-w-0">
                <p className="font-medium text-zinc-900">{i.qty}x {i.name}</p>
                {i.note && <p className="text-xs italic text-zinc-500">Catatan: {i.note}</p>}
                {bill.status === "active" && <ItemStatus item={i} />}
              </div>
              <span className="font-mono text-sm tabular-nums">{rp(i.qty * i.price)}</span>
            </div>
          ))}
        </div>
        {bill.items.length > 0 && <TotalsBlock totals={bill.totals} />}
        {bill.payment && (
          <div className="flex justify-between text-sm text-zinc-600">
            <span>Dibayar {rp(bill.payment.amount_paid)}</span>
            <span>Kembali {rp(bill.payment.change)}</span>
          </div>
        )}
        {bill.status === "paid" && (
          <Button data-testid="bill-detail-print-btn" variant="outline" onClick={() => printReceipt(bill, settings)}>
            <Printer className="mr-2 h-4 w-4" /> Cetak Struk
          </Button>
        )}
      </DialogContent>
    </Dialog>
  );
}

const Info = ({ k, v }) => (
  <div>
    <p className="text-xs text-zinc-500">{k}</p>
    <p className="font-semibold text-zinc-900 truncate">{v || "-"}</p>
  </div>
);
